
<div class="custom-toast" [ngClass]="toastType">

  <div class="toast-icon">
    <ng-container [ngSwitch]="toastType">

      <svg *ngSwitchCase="'toast-info'" width="22" height="22" viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="10" fill="#3B82F6"/>
        <rect x="9" y="9" width="2" height="6" rx="1" fill="white"/>
        <rect x="9" y="5" width="2" height="2" rx="1" fill="white"/>
      </svg>

      <svg *ngSwitchCase="'toast-success'" width="22" height="22" viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="10" fill="#22C55E"/>
        <path d="M5 10l4 4 6-6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>

      <svg *ngSwitchCase="'toast-warning'" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path d="M11 2L1.5 19h19L11 2z" fill="#F59E0B"/>
        <rect x="10" y="8.5" width="2" height="5.5" rx="1" fill="white"/>
        <rect x="10" y="15.5" width="2" height="2" rx="1" fill="white"/>
      </svg>

      <svg *ngSwitchCase="'toast-error'" width="22" height="22" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="3" width="18" height="18" rx="3" transform="rotate(45 12 12)" fill="#EF4444"/>
        <rect x="11" y="7" width="2" height="7" rx="1" fill="white"/>
        <rect x="11" y="16" width="2" height="2" rx="1" fill="white"/>
      </svg>

    </ng-container>
  </div>

  <div class="toast-content">
    <span class="toast-title">{{ title || autoTitle }}</span><span class="toast-message" *ngIf="message">{{ message }}</span>
  </div>

  <button class="toast-close" (click)="remove()">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </button>

</div>